import * as DocumentTemplateActions from "./templateActions";

export default DocumentTemplateActions;



// WEBPACK FOOTER //
// ./src/actions/DocumentTemplateActions/index.js